import _isEqual from "lodash/isEqual";
import _nth from "lodash/nth";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import cx from 'classnames';
import { ClickOutside } from '@nextiva/next-ui';
import TextColumn from "./TextColumn";
import DateColumn, { DateTimeColumn } from "./DateColumn";
import NumericColumn from "./NumericColumn";
import UniqueColumn from "./UniqueColumn";
import MultiSelectColumn from "./MultiSelectColumn";
import ClearFilterButton from "./ClearFilterButton";

var getComponent = function getComponent(type) {
  switch (type) {
    case 'text':
      return TextColumn;

    case 'date':
      return DateColumn;

    case 'datetime':
      return DateTimeColumn;

    case 'number':
    case 'currency':
      return NumericColumn;

    case 'boolean':
    case 'radio':
      return UniqueColumn;

    case 'dropdown':
    case 'multiselect':
      return MultiSelectColumn;

    default:
      return TextColumn;
  }
};

var TypeFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(TypeFilter, _Component);

  function TypeFilter(props) {
    var _this;

    _classCallCheck(this, TypeFilter);

    _this = _possibleConstructorReturn(this, (TypeFilter.__proto__ || Object.getPrototypeOf(TypeFilter)).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var type = props.type,
        filterData = props.filterData;
    _this.ColumnComponent = getComponent(type);
    _this.state = _this.ColumnComponent.mapIncomingFilters(filterData || {}, _this.getDefaultOperator());
    return _this;
  }

  _createClass(TypeFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          operator = _state.operator,
          values = _state.values;
      var _props = this.props,
          loadOptions = _props.loadOptions,
          onFiltersChange = _props.onFiltersChange;
      var stateIsChanged = !_isEqual(prevState.values, values) || prevState.operator !== operator;

      if (loadOptions && stateIsChanged) {
        onFiltersChange(this.getNextState());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          type = _props2.type,
          title = _props2.title,
          options = _props2.options,
          loadOptions = _props2.loadOptions,
          className = _props2.className,
          columnDataOptions = _props2.columnDataOptions,
          blockName = _props2.blockName,
          other = _objectWithoutProperties(_props2, ["type", "title", "options", "loadOptions", "className", "columnDataOptions", "blockName"]);

      var _state2 = this.state,
          operator = _state2.operator,
          values = _state2.values;
      var Component = this.ColumnComponent;
      var dropdownClassName = "".concat(blockName, "__dropdown"); // className that will be ignored by checking in ClickOutside component

      var outsideClickIgnoreClass = 'outside-click-ignore';
      return React.createElement(ClickOutside, {
        outsideClickIgnoreClass: outsideClickIgnoreClass,
        onClickOutside: this.handleClickOutside
      }, React.createElement("div", {
        tabIndex: "0",
        className: cx(blockName, className),
        onKeyDown: this.handleEsc
      }, React.createElement("div", {
        className: "".concat(blockName, "__header")
      }, "Show data if..."), React.createElement("div", {
        className: "".concat(blockName, "__body")
      }, React.createElement(Component, _extends({
        type: type,
        title: title,
        values: values,
        operator: operator,
        options: options,
        loadOptions: loadOptions,
        onOperatorChange: this.handleOperatorChange,
        onFilterChange: loadOptions ? this.handleAsyncSearchableFilterChange : this.handleFilterChange,
        isNullTypeOperator: this.isNullTypeOperator(),
        onKeyDown: this.handleKeyDown,
        onSelectFocus: this.handleSelectFocus,
        defaultOperator: this.getDefaultOperator(),
        operatorOptions: this.getOperatorOptions(),
        columnDataOptions: columnDataOptions,
        portalWrapperClass: outsideClickIgnoreClass
      }, other))), React.createElement("div", {
        className: "".concat(blockName, "__footer")
      }, React.createElement(ClearFilterButton, {
        ref: function ref(btn) {
          return _this2.dropdown = btn;
        },
        onResetSingle: this.handleResetSingle,
        onResetAll: this.handleResetAll,
        dropdownClassName: cx(dropdownClassName, outsideClickIgnoreClass)
      }))));
    }
  }]);

  return TypeFilter;
}(Component);

Object.defineProperty(TypeFilter, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    filterData: PropTypes.object,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    title: PropTypes.string,
    options: PropTypes.array,
    loadOptions: PropTypes.func,
    onFiltersChange: PropTypes.func,
    type: PropTypes.string.isRequired,
    typeConfig: PropTypes.object,
    columnDataOptions: PropTypes.object,
    blockName: PropTypes.string
  }
});
Object.defineProperty(TypeFilter, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    typeConfig: {},
    blockName: 'nx-type-filter'
  }
});

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  Object.defineProperty(this, "getDefaultOperator", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this3$props = _this3.props,
          type = _this3$props.type,
          typeConfig = _this3$props.typeConfig;

      if (typeConfig.defaultOperator) {
        return typeConfig.defaultOperator;
      }

      return _this3.ColumnComponent.defaultOperator(_objectSpread({
        type: type
      }, typeConfig));
    }
  });
  Object.defineProperty(this, "getOperatorOptions", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this3$props2 = _this3.props,
          typeConfig = _this3$props2.typeConfig,
          title = _this3$props2.title;

      if (Array.isArray(typeConfig.operatorOptions)) {
        return typeConfig.operatorOptions;
      }

      return _this3.ColumnComponent.getOperatorOptions({
        title: title,
        defaultOperator: _this3.getDefaultOperator()
      }).filter(function (operator) {
        return !(['empty', 'notEmpty'].includes(operator.value) && typeConfig.disableEmptyOption === true);
      });
    }
  });
  Object.defineProperty(this, "handleResetSingle", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this3.setState({
        operator: _this3.getDefaultOperator(),
        values: undefined
      });
    }
  });
  Object.defineProperty(this, "isNullTypeOperator", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return ['empty', 'notEmpty'].includes(_this3.state.operator);
    }
  });
  Object.defineProperty(this, "getValues", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this3.state.values || _this3.isNullTypeOperator()) {
        return undefined;
      } // when switching between operators, try to fill with what is currently in state


      var value = _nth(_this3.state.values, 0);

      if (value !== undefined) return [value];
    }
  });
  Object.defineProperty(this, "handleOperatorChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref) {
      var operator = _ref.value;

      _this3.setState({
        operator: operator
      });
    }
  });
  Object.defineProperty(this, "handleAsyncSearchableFilterChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      var selectedValues = _this3.state.values || []; // add, if one element is received and it does not exist in selectedValues

      if (values.length === 1 && selectedValues.indexOf(values[0]) === -1) {
        selectedValues = _toConsumableArray(selectedValues).concat(_toConsumableArray(values));
      } else {
        // in other case it is deletion - replace selectedValues by received values
        selectedValues = values;
      }

      _this3.setState({
        values: selectedValues
      });
    }
  });
  Object.defineProperty(this, "handleFilterChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      _this3.setState({
        values: values
      });
    }
  });
  Object.defineProperty(this, "shouldTriggerChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this3$state = _this3.state,
          stateOperator = _this3$state.operator,
          stateValues = _this3$state.values;

      var _ref2 = _this3.props.filterData || {},
          operator = _ref2.operator,
          values = _ref2.values;

      if (operator !== stateOperator && ['empty', 'notEmpty'].includes(stateOperator)) {
        return true;
      }

      if (!stateValues && !values) {
        return false;
      }

      var state = {
        operator: stateOperator,
        values: stateValues
      };
      return !_isEqual(state, {
        operator: operator,
        values: values
      });
    }
  });
  Object.defineProperty(this, "getNextState", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this3$state2 = _this3.state,
          operator = _this3$state2.operator,
          values = _this3$state2.values;
      var _this3$props3 = _this3.props,
          type = _this3$props3.type,
          columnDataOptions = _this3$props3.columnDataOptions;

      var nextState = _this3.ColumnComponent.mapOutgoingFilters({
        operator: operator,
        values: values,
        columnDataOptions: columnDataOptions
      });

      return _objectSpread({}, nextState, {
        type: type
      });
    }
  });
  Object.defineProperty(this, "handleClickOutside", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(e) {
      var _this3$state3 = _this3.state,
          operator = _this3$state3.operator,
          values = _this3$state3.values;
      var _this3$props4 = _this3.props,
          loadOptions = _this3$props4.loadOptions,
          onClose = _this3$props4.onClose,
          onFiltersChange = _this3$props4.onFiltersChange;

      if (!_this3.shouldTriggerChange()) {
        return _this3.props.onClose(e, null);
      }

      if (_this3.ColumnComponent.validate) {
        var result = _this3.ColumnComponent.validate({
          operator: operator,
          values: values
        });

        if (result && result.error) {
          return _this3.setState(result.nextState);
        }
      } // call onFilterChange when clicking outside only for non asyncSearchable filters


      if (!loadOptions) {
        onFiltersChange(_this3.getNextState());
      }

      return onClose(e);
    }
  });
  Object.defineProperty(this, "handleEsc", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      if (keycode(event) === 'esc') {
        _this3.props.onClose(event, null);
      }
    }
  });
  Object.defineProperty(this, "handleKeyDown", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      if (keycode(event) === 'enter') {
        _this3.handleClickOutside(event);
      }
    }
  });
  Object.defineProperty(this, "handleResetAll", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this3.handleResetSingle();

      _this3.props.onResetAll();
    }
  });
  Object.defineProperty(this, "handleSelectFocus", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this3.dropdown.closePopover();
    }
  });
};

export default TypeFilter;